import React from 'react';
import { sendStartupMetrics } from 'api/services/metrics/startup.services';
import { getRegion } from 'utils/Region';

class StartupErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    sessionStorage.removeItem('appHasLoaded');
    this.state = { hasError: false };
    this.startTime = performance.now();
    this.isFirstLoad = this.checkIfFirstLoad();
  }

  checkIfFirstLoad() {
    const hasLoadedBefore = sessionStorage.getItem('appHasLoaded');

    if (!hasLoadedBefore) {
      sessionStorage.setItem('appHasLoaded', 'true');
      return true; // Es primera carga
    }

    return false;
  }

  componentDidCatch(error, errorInfo) {
    // Solo enviar error si es la primera carga
    if (this.isFirstLoad) {
      this.sendStartupError(error, errorInfo);
    } else {
      console.error(error);
    }
  }

  sendStartupError(error, errorInfo) {
    const timeToError = Math.round(performance.now() - this.startTime);
    const errorType = this.getErrorType(error, timeToError);

    const errorMetrics = {
      eventType: 'AppStartupMetricsError',
      errorType,
      appVersion: __VERSION__,
      sessionId: crypto.randomUUID(),
      language: 'javascript',
      platform: 'web',
      deviceType: 'web',
      deviceBrand: navigator.vendor,
      deviceOS: navigator.userAgent,
      region: getRegion(),
    };

    console.error('AppStartupMetricsError:', errorMetrics);
    sendStartupMetrics(errorMetrics);
  }

  getErrorType(error, timeToError) {
    if (timeToError > 15000) return 'timeout';

    if (
      error.message?.includes('fetch') ||
      error.message?.includes('network') ||
      error.message?.includes('load')
    ) {
      return 'data_load_failure';
    }

    if (error.name === 'TypeError' || error.name === 'ReferenceError') {
      return 'crash';
    }

    return 'render_failure';
  }

  render() {
    return this.props.children;
  }
}

export default StartupErrorBoundary;
